import locally from 'locally';
var LocalStore = locally.Store;
export default new LocalStore();


/** WEBPACK FOOTER **
 ** ./scripts/storage.js
 **/